import { AfterViewInit, Directive, ElementRef, inject, input } from '@angular/core';

@Directive({
  selector: '[cueClasserizeParent]',
  standalone: true,
})
export class ClasserizeParentDirective implements AfterViewInit {
  private elementRef = inject<ElementRef<HTMLElement>>(ElementRef<HTMLElement>);
  parentClass = input('classerizedParentClass');
  parentLevel = input(1);

  ngAfterViewInit(): void {
    let parentPointer: HTMLElement | null = this.elementRef.nativeElement;
    for (let i = 0; i < this.parentLevel(); i++) {
      parentPointer = parentPointer.parentElement;
      if (parentPointer == null) {
        break;
      }
    }
    if (parentPointer) {
      parentPointer.classList.add(this.parentClass());
    }
  }
}
